module.exports = __webpack_public_path__ + "img/astral_16.52999d24.svg";